import * as React from "react";
import { Link } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import AdbIcon from "@mui/icons-material/Adb";

const pages = [
  "Chat",
  "About",
  // "Account",
  // "Translate",
  // "Register",
  // "Login",
  // "Subscribe",
  // "Logout",
];
const settings = ["Profile", "Dashboard", "Logout"];

function ResponsiveAppBar({
  toggleLanguage,
  handleLogout,
  guestOrUser,
  subscriptionStatus,
  languageTranslations,
}) {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <AppBar
      sx={{ backgroundColor: "#541b14" }}
      // color={"primary"}
      position="static"
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {/* <AdbIcon sx={{ display: { xs: "none", md: "flex" }, mr: 1 }} /> */}
          <Link
            to="/"
            style={{
              textDecoration: "none",
              color: "inherit",
            }}
          >
            <Typography
              variant="h6"
              noWrap
              sx={{
                mr: 2,
                display: { xs: "none", md: "flex" },
                fontFamily: "monospace",
                fontWeight: 700,
                letterSpacing: ".3rem",
              }}
            >
              MALAYALAM.AI
            </Typography>
          </Link>

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {pages.map((page) => {
                if (page === "Register" && guestOrUser === "user") return null;
                if (page === "Login" && guestOrUser === "user") return null;
                if (page === "Subscribe" && guestOrUser === "guest")
                  return null;
                if (
                  page === "Subscribe" &&
                  guestOrUser === "user" &&
                  subscriptionStatus == true
                )
                  return null;
                if (page === "Account" && guestOrUser === "guest") return null;
                if (page === "Logout" && guestOrUser === "guest") return null;
                return (
                  <MenuItem
                    key={page}
                    onClick={() => {
                      if (page === "Translate") {
                        toggleLanguage();
                        handleCloseNavMenu();
                      } else if (page === "Logout") {
                        handleLogout();
                        handleCloseNavMenu();
                      } else {
                        handleCloseNavMenu();
                      }
                    }}
                  >
                    {page !== "Translate" ? (
                      <Link
                        to={page === "Chat" ? "/" : `/${page.toLowerCase()}`}
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        <Typography textAlign="center">{page}</Typography>
                      </Link>
                    ) : (
                      <Typography textAlign="center">{page}</Typography>
                    )}
                  </MenuItem>
                );
              })}
            </Menu>
          </Box>
          {/* <AdbIcon sx={{ display: { xs: "flex", md: "none" }, mr: 1 }} /> */}
          {/* <Link
            to="/"
            style={{
              textDecoration: "none",
              color: "inherit",
            }}
          >
            <Typography
              variant="h5"
              noWrap
              component="div"
              sx={{
                mr: 2,
                display: { xs: "flex", md: "none" },
                flexGrow: 1,
                fontFamily: "monospace",
                fontWeight: 700,
                letterSpacing: ".3rem",
                color: "inherit",
                textDecoration: "none",
              }}
            >
              M.AI
            </Typography>
          </Link> */}
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {pages.map((page) => {
              if (page === "Register" && guestOrUser === "user") return null;
              if (page === "Login" && guestOrUser === "user") return null;
              if (page === "Subscribe" && guestOrUser === "guest") return null;
              if (
                page === "Subscribe" &&
                guestOrUser === "user" &&
                subscriptionStatus == true
              )
                return null;
              if (page === "Account" && guestOrUser === "guest") return null;
              if (page === "Logout" && guestOrUser === "guest") return null;
              return (
                <Button
                  key={page}
                  onClick={() => {
                    if (page === "Translate") {
                      toggleLanguage();
                    } else if (page === "Logout") {
                      handleLogout();
                    } else {
                      handleCloseNavMenu();
                    }
                  }}
                  sx={{ my: 2, color: "white", display: "block" }}
                >
                  {page !== "Translate" ? (
                    <Link
                      to={page === "Chat" ? "/" : `/${page.toLowerCase()}`}
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      {page}
                    </Link>
                  ) : (
                    page
                  )}
                </Button>
              );
            })}
          </Box>

          {/* <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem
                  key={setting}
                  onClick={() => {
                    if (setting === "Logout") {
                      handleLogout();
                    }
                    handleCloseUserMenu();
                  }}
                >
                  <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box> */}
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;
